<template>
	<div class="filterable-list__results-info">
      <p class="filterable-list__results-text">
		<strong class="filterable-list__results-cap">{{thema}}:{{'\xa0'}}</strong>
		<strong class="filterable-list__total-item-count">{{count}}{{'\xa0'}}</strong>
		<span v-if="count == '1'"><strong>{{listTitlelngtxt.result_txt}}</strong></span>
		<span v-else><strong>{{listTitlelngtxt.results_txt}}</strong></span>
		<span v-if="eventfilterstr !== undefined">{{'\xa0'}}{{listTitlelngtxt.resultsfilter_txt}}</span>
      </p>
    </div>
</template>
<script>
export default {
	name: 'FilterableListTitle',
	computed:{
		count() {
			return  this.$store.getters.count;
		},
		eventfilterstr() {
			return this.$store.getters.eventfilter;
		},
		thema() {
			let thema_label="";
			if(this.$store.state.thema === undefined){
				thema_label = this.listTitlelngtxt.all_txt;
			} else {
				let filterslist = this.$store.getters.filters;
				let filterlabel = "Alle";
				for ( let i=0; i<filterslist.length; i++ ) {
					if(filterslist[i].value == this.$store.state.thema) {
						filterlabel = filterslist[i].label;
					}
				}
				thema_label = filterlabel;
			}
			return thema_label;
		},
		listTitlelngtxt() {
      		return this.$store.getters.lngtxt.filterablelist;
		}
	}
}
</script>
